import clsx from 'clsx';
import React, { FC } from 'react';
import ReactDOM from 'react-dom';

import { useRootElement } from '@/hooks/useRootElement';

import cn from './style.module.sass';

interface IProps {
	showOverlay: boolean;
	closeOverlay: () => void;
	className?: string;
	id?: string;
}

const BackOverlay: FC<IProps> = ({ showOverlay, closeOverlay, className, id }) => {
	const node = useRootElement('body');

	if (!node) return null;

	return ReactDOM.createPortal(
		<div id={id} className={clsx(cn.overlay, className)} onClick={closeOverlay} role="presentation" />,
		node
	);
};

export default BackOverlay;
